import React from 'react';

function Promise() {
    return (
        <div className="w-full h-[406px] py-16 bg-sky-100 flex-col justify-center items-center gap-2.5 inline-flex">
    <div className="w-[1120px] justify-center items-center gap-[34px] inline-flex">
        <div className="grow shrink basis-0 flex-col justify-start items-start gap-14 inline-flex">
            <div className="self-stretch text-stone-700 text-5xl font-semibold font-['Pretendard'] leading-[60px]">
                꼼꼼함과 기술에 대한 집요함으로 어떤 문제든 <br/>
                해결해내는 프론트엔드 개발자가 되겠습니다. <br/>
                감사합니다! 😊</div>
        </div>
    </div>
</div>
    );
}
export default Promise;